module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_View_16"],"path":[{"$":{"d":"M8,11a3,3,0,1,1,3-3A3,3,0,0,1,8,11Zm0,2C3.72,13,.36,8.49.22,8.3L0,8l.22-.3C.36,7.51,3.72,3,8,3s7.64,4.51,7.78,4.7L16,8l-.22.3C15.64,8.49,12.28,13,8,13ZM1.26,8c.8,1,3.56,4,6.74,4s5.94-3,6.74-4C13.94,7,11.18,4,8,4S2.06,7,1.26,8Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_View_16.svg
// module id = HLXu
// module chunks = 1